// @flow

import React from 'react';
import Dialog, { DialogButton } from '../../components/Dialog';
import { Centered } from '../../components';
import { Anchor } from '../components';

type Props = {
  onClose?: Function,
  onAccept: Function,
  onDecline: Function,
};

const noop = () => {};
const AcceptTermsDialog = (props: Props) => (
  <Dialog onClose={props.onClose || noop}>
    <Centered>
      {'You must accept the'}{' '}
      <Anchor href="https://parkchicago.com/terms/" target="_blank">
        {'Terms and Conditions'}
      </Anchor>
      {' of the ParkChicago Fleet program before using this application.'}
    </Centered>
    <DialogButton onClick={props.onAccept}>{'Accept'}</DialogButton>
    <DialogButton variant="secondary" onClick={props.onDecline}>
      {'Decline'}
    </DialogButton>
  </Dialog>
);

export default AcceptTermsDialog;



// WEBPACK FOOTER //
// ./src/Auth/Signup/AcceptTermsDialog.js